<app-grouped-page-container class="impact-analysis" [groups]="groups" [title]="title" [props]="props" (groupChange)="onGroupChange($event)"></app-grouped-page-container>
